/*
 * dispenseEproDevicePopupModule
 * */

import resetPinEproDevicePopupComponent from './resetPinEproDevicePopup.component';

const resetPinEproDevicePopupModule = angular.module('app.components.resetPinEproDevicePopup', [])
	.component('resetPinEproDevicePopup', resetPinEproDevicePopupComponent)
	.name;

export default resetPinEproDevicePopupModule;
